import { Controller } from "@hotwired/stimulus"

const MAX_DIMENSION = 1600
const JPEG_QUALITY = 0.8

export default class extends Controller {
  static targets = ["input", "preview"]

  compress(event) {
    const file = event.target.files?.[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = () => this.processImage(reader.result, file.name)
    reader.readAsDataURL(file)
  }

  processImage(dataUrl, originalName) {
    const image = new Image()
    image.onload = () => {
      const canvas = document.createElement("canvas")
      const scale = Math.min(1, MAX_DIMENSION / Math.max(image.width, image.height))
      canvas.width = Math.round(image.width * scale)
      canvas.height = Math.round(image.height * scale)

      const context = canvas.getContext("2d")
      context.drawImage(image, 0, 0, canvas.width, canvas.height)

      canvas.toBlob(
        (blob) => {
          if (!blob) return

          const compressedName = originalName.replace(/\.\w+$/, "") + ".jpg"
          const compressedFile = new File([blob], compressedName, { type: "image/jpeg" })
          const dataTransfer = new DataTransfer()
          dataTransfer.items.add(compressedFile)
          this.inputTarget.files = dataTransfer.files

          if (this.hasPreviewTarget) {
            this.previewTarget.src = URL.createObjectURL(blob)
            this.previewTarget.style.display = "block"
          }
        },
        "image/jpeg",
        JPEG_QUALITY
      )
    }
    image.src = dataUrl
  }
}
